import React from 'react';

const TextExtractionBox = ({
  extractedText = '',
  isExtracting = false,
  extractionProgress,
  onTextChange,
  className = '',
  placeholder = 'Extracted text will appear here...',
  readOnly = true,
  ...props
}) => {
  return (
    <div className={`w-full ${className}`}>
      <div className="bg-white border-2 border-gray-200 rounded-2xl shadow-sm overflow-hidden">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-3 h-3 bg-red-500 rounded-full"></div>
              <h3 className="text-lg font-semibold text-gray-900">
                Extracted Text
              </h3>
              {!isExtracting && extractedText && (
                <span className="px-2 py-1 text-xs font-medium bg-green-100 text-green-800 rounded-full">
                  Ready
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Progress Bar */}
        {isExtracting && extractionProgress !== undefined && (
          <div className="px-6 py-4 border-b border-gray-200 bg-blue-50">
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-blue-900">
                  Extracting text from document...
                </span>
                <span className="text-sm font-medium text-blue-700">
                  {extractionProgress}%
                </span>
              </div>
              <div className="w-full bg-blue-200 rounded-full h-2.5">
                <div 
                  className="bg-blue-600 h-2.5 rounded-full transition-all duration-300 ease-out"
                  style={{ width: `${extractionProgress}%` }}
                ></div>
              </div>
            </div>
          </div>
        )}

        {/* Text Content */}
        <div className="p-6 max-h-96 overflow-hidden">
          {isExtracting ? (
            <div className="min-h-[200px] flex items-center justify-center">
              <div className="text-center space-y-3">
                <p className="text-gray-600">Processing your document...</p>
              </div>
            </div>
          ) : extractedText ? (
            <div className="max-h-80 overflow-y-auto border-2 border-gray-200 rounded-xl bg-gray-50">
              <div className="p-4">
                <p className="text-gray-900 text-sm leading-relaxed whitespace-pre-wrap">
                  {extractedText}
                </p>
              </div>
            </div>
          ) : (
            <div className="min-h-[200px] flex items-center justify-center text-center">
              <div className="space-y-3">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto">
                  <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <p className="text-gray-600">No text extracted yet</p>
                <p className="text-sm text-gray-500">Upload a document to extract text</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TextExtractionBox;
